import React from 'react';

import { Episode } from '~/src/common/lean-back/Episode';
import { MediaPlayerModal } from '~/src/components/MediaPlayer';

import { PlaybackProvider } from './PlaybackProvider';
import { Player } from './Player';

interface Props {
  open: boolean;
  onClose: () => void;
  initialEpisode: Episode;
}

export const Modal: React.FC<Props> = ({ onClose, open, initialEpisode }) => {
  return (
    <MediaPlayerModal open={open} onClose={onClose}>
      <PlaybackProvider initialEpisode={initialEpisode}>
        <Player />
      </PlaybackProvider>
    </MediaPlayerModal>
  );
};
